import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "row mb-4" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "row mb-4" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "row mb-4" }
const _hoisted_17 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_18 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_19 = { class: "row mb-4" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = {
  key: 0,
  class: "fw-bold mb-1"
}
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = {
  key: 0,
  class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mt-25"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "table" }
const _hoisted_28 = { class: "fw-bold mt-10" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "table" }
const _hoisted_31 = { class: "fw-bold mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
            _createVNode(_component_router_link, {
              to: "/paiements/liste-paiements",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour ")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Date de Paiement :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.format_Date(_ctx.paiement?.datePaiement) || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Montant Payé :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.montantPaye || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Montant Restant :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.montantRest || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Reliquat :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.reliquat || 'N/A'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Référence Opération :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.refOperation || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Numéro Mobile :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.numeroMobileMoney || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Mode de Paiement :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.modepaiement?.libelle || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Facture :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.facture || 'N/A'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.paiement?.modepaiement?.id === 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Numéro de Virement :", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.numeroVirement || 'N/A'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.paiement?.modepaiement?.id === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[11] || (_cache[11] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Numéro de Chèque :", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.nomCheque || 'N/A'), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_ctx.paiement?.modepaiement?.id === 3 || _ctx.paiement?.modepaiement?.id === 4)
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Banque :"))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.banque?.denominationBanque || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Commande :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.commande?.refCom || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Montant TTC :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.paiement?.montantDu || 'N/A'), 1)
            ])
          ]),
          (_ctx.paiement?.modepaiement?.id === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "fw-bold text-black mb-15 mb-md-25" }, "Billetage", -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[15] || (_cache[15] = _createElementVNode("h6", { class: "fw-bold text-black mb-10" }, "Encaissement", -1)),
                    _createElementVNode("table", _hoisted_27, [
                      _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Monnaie"),
                          _createElementVNode("th", null, "Quantité"),
                          _createElementVNode("th", null, "Montant")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paiement?.billetages.filter(b => b.sens === 'ENTREE'), (billetage, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(billetage?.libelle || 'N/A'), 1),
                            _createElementVNode("td", null, _toDisplayString(billetage?.qteBillet || 'N/A'), 1),
                            _createElementVNode("td", null, _toDisplayString(billetage?.montant || 'N/A'), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_28, " Total Encaissement : " + _toDisplayString(_ctx.paiement?.montantTotalEncaissement || 'N/A') + " Fcfa ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _cache[17] || (_cache[17] = _createElementVNode("h6", { class: "fw-bold text-black mb-10" }, "Reliquat", -1)),
                    _createElementVNode("table", _hoisted_30, [
                      _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Monnaie"),
                          _createElementVNode("th", null, "Quantité"),
                          _createElementVNode("th", null, "Montant")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paiement?.billetages.filter(b => b.sens === 'SORTIE'), (billetage, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(billetage?.libelle || 'N/A'), 1),
                            _createElementVNode("td", null, _toDisplayString(billetage?.qteBillet || 'N/A'), 1),
                            _createElementVNode("td", null, _toDisplayString(billetage?.montant || 'N/A'), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_31, " Total Reliquat : " + _toDisplayString(_ctx.paiement?.montantTotalSortie || 'N/A') + " Fcfa ", 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}